import axiosClient from "./axios-client";
 
export const updateChunkContent = async (chunkId, content) => {
    const response = await axiosClient.patch(
        `/chunks/${chunkId}`,
        { content }
    );
 
    return response.data;
};
 